import React, { useState, useEffect } from "react";
import {
  handleRadioChange,
  handleDateChange,
  handleMinNightsChange,
} from "./adminUtils";
import RoomSelector from "./RoomSelector";
import DateRangePicker from "./AdminDateRangePicker";
import {
  db,
  addPriceUpdate,
  updateAvailability,
  fetchAllDailyPrices,
  addMinNightsSetting,
  fetchMinNights,
} from "../../firebaseConfig";
import { deleteDoc, doc, updateDoc } from "firebase/firestore";
import {
  Typography,
  Stack,
  Button,
  Box,
  TextField,
  Divider,
  IconButton,
  CircularProgress,
  InputAdornment,
  Tabs,
  Tab,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Add, Remove } from "@mui/icons-material";
import RadioSelector from "./RadioSelector";

const TabManageBookings = ({
  rooms,
  availabilityDocuments,
  isTabletOrMobile,
  tabValue,
}) => {
  const [value, setValue] = useState("disponibilità");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedRoomsMinNights, setSelectedRoomsMinNights] = useState([]);
  const [bookingDates, setBookingDates] = useState({
    startDate: "",
    endDate: "",
  });
  const [subTabValue, setSubTabValue] = useState(0);

  const handleChangeTab = (event, newValue) => {
    setSubTabValue(newValue);
  };
  const [price, setPrice] = useState("0");
  const [minNights, setMinNights] = useState(1); // stato per il numero minimo di notti
  const [dailyPrices, setDailyPrices] = useState([]);
  const [minNightsData, setMinNightsData] = useState([]);
  const [adultsCount, setAdultsCount] = useState(0);
  const [childrenCount, setChildrenCount] = useState(0);
  const [prenotazione, setPrenotazione] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  // Per la modifica del prezzo
  const [editingPriceId, setEditingPriceId] = useState(null);
  const [newPrice, setNewPrice] = useState("");
  const [editingMinNightsId, setEditingMinNightsId] = useState(null);
  const [newMinNights, setNewMinNights] = useState("");

  useEffect(() => {
    const loadPrices = async () => {
      const prices = await fetchAllDailyPrices();
      setDailyPrices(prices);
    };

    const loadMinNights = async () => {
      const minNights = await fetchMinNights();
      setMinNightsData(minNights);
    };

    // Carica i prezzi giornalieri
    loadPrices();

    // Carica i minimi di notti per la stanza selezionata
    loadMinNights();
  }, [selectedRoom, selectedRoomsMinNights]); // Esegui ogni volta che selectedRoom cambia
  const handleSubmit = async () => {
    if (!bookingDates.startDate || !bookingDates.endDate) {
      console.error("Le date di inizio e fine sono necessarie.");
      return;
    }

    if (
      value === "prezzo" &&
      selectedRoom &&
      bookingDates.startDate &&
      bookingDates.endDate
    ) {
      await addPriceUpdate(
        selectedRoom,
        bookingDates.startDate,
        bookingDates.endDate,
        price
      );
    } else if (
      value === "disponibilità" &&
      selectedRoom &&
      bookingDates.startDate &&
      bookingDates.endDate
    ) {
      await updateAvailability(
        selectedRoom,
        bookingDates.startDate,
        bookingDates.endDate,
        adultsCount,
        childrenCount,
        customerPhone,
        customerName,
        email,
        newPrice,
        newPrice, // Aggiungo totalPrice (stesso valore di price per admin)
        true,
        false,
        {},
        "",
        "it"
      );
      window.location.reload();
    } else if (
      value === "minNights" &&
      selectedRoomsMinNights &&
      bookingDates.startDate &&
      bookingDates.endDate &&
      minNights
    ) {
      await addMinNightsSetting(
        selectedRoomsMinNights,
        bookingDates.startDate,
        bookingDates.endDate,
        minNights
      );
      alert("Minimo notti aggiornato con successo!");
      window.location.reload();
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleDeletePrice = async (priceId) => {
    try {
      await deleteDoc(doc(db, "dailyPrices", priceId));
      setDailyPrices((prevPrices) =>
        prevPrices.filter((price) => price.id !== priceId)
      );
      alert("Prezzo cancellato con successo!");
    } catch (error) {
      console.error("Errore durante la cancellazione del prezzo:", error);
    }
  };
  const handleDeleteMinNights = async (minNightId) => {
    try {
      await deleteDoc(doc(db, "minNightsSettings", minNightId));
      setMinNightsData((prevMinNights) =>
        prevMinNights.filter((minNights) => minNights.id !== minNightId)
      );
      alert("Minimo notti cancellato con successo!");
    } catch (error) {
      console.error("Errore durante la cancellazione del minimo notti:", error);
    }
  };
  const handleEditPrice = (priceId, currentPrice) => {
    setEditingPriceId(priceId);
    setNewPrice(currentPrice);
  };

  const handleSavePrice = async (priceId) => {
    try {
      const priceRef = doc(db, "dailyPrices", priceId);
      await updateDoc(priceRef, { price: parseFloat(newPrice) });
      setDailyPrices((prevPrices) =>
        prevPrices.map((price) =>
          price.id === priceId
            ? { ...price, price: parseFloat(newPrice) }
            : price
        )
      );
      setEditingPriceId(null);
      setNewPrice("");
      alert("Prezzo aggiornato con successo!");
    } catch (error) {
      console.error("Errore durante l'aggiornamento del prezzo:", error);
    }
  };

  const [groupedPrices, setGroupedPrices] = useState({});
  const groupPricesByMonthAndRoom = (prices) => {
    return prices.reduce((acc, price) => {
      const month = price.startDate
        .toDate()
        .toLocaleString("default", { month: "long", year: "numeric" }); // Ottieni il mese
      const roomTitle = getRoomTitle(price.roomId); // Ottieni il titolo della camera

      // Crea una nuova struttura se non esiste già
      if (!acc[month]) {
        acc[month] = {};
      }
      if (!acc[month][roomTitle]) {
        acc[month][roomTitle] = [];
      }

      acc[month][roomTitle].push(price);
      return acc;
    }, {});
  };
  useEffect(() => {
    const loadPrices = async () => {
      const prices = await fetchAllDailyPrices();
      const grouped = groupPricesByMonthAndRoom(prices); // Raggruppa i prezzi
      setGroupedPrices(grouped);
    };
    loadPrices();
  }, [groupPricesByMonthAndRoom]);

  const NumberInput = ({ label, value, onChange }) => {
    return (
      <TextField
        label={label}
        type="number"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        inputProps={{ min: 0 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => onChange(value > 0 ? value - 1 : 0)}
                size="small"
                disabled={value <= 0}
              >
                <Remove fontSize="small" />
              </IconButton>
              <IconButton
                onClick={() => onChange(value + 1)}
                size="small"
                disabled={value < 0}
              >
                <Add fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    );
  };

  const getRoomTitle = (room) => {
    switch (room) {
      case "room1":
        return "Inno al Re";
      case "room2":
        return "Il Barbiere Di Siviglia";
      case "room3":
        return "L'Osteria Di Marechiaro";
      case "room4":
        return "La Molinara";
      case "room5":
        return "Il Matrimonio Inaspettato";
      default:
        return "Seleziona camera";
    }
  };

  return (
    <Box sx={{ backgroundColor: "#f0f0f0", pb: "20vh" }}>
      <Box display={tabValue === 2 ? "block" : "none"}>
        <Typography
          variant="h5"
          sx={{
            borderBottom: "1px solid black",
            p: 2,
            fontFamily: "ivymode",
            letterSpacing: 1.3,
          }}
        >
          GESTIONE CAMERE
        </Typography>
        <form
          style={{
            backgroundColor: "#f0f0f0",
            gap: "20px",
            width: isTabletOrMobile ? "100%" : undefined,
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit();
          }}
        >
          <Box margin={2} width="100%">
            <Stack
              spacing={2}
              sx={{
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "ivymode",
                  marginBottom: "10px",
                }}
              >
                1. Seleziona l'operazione da eseguire
              </Typography>

              <Stack spacing={1}>
                <Box display={"flex"} alignItems="center">
                  <input
                    type="radio"
                    id="option_disponibilita"
                    name="options"
                    value="disponibilità"
                    checked={value === "disponibilità"}
                    onChange={handleChange}
                    style={{ marginRight: "10px" }} // Optional for spacing
                  />
                  <label
                    htmlFor="option_disponibilita"
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      sx={{
                        fontSize: "18px",
                      }}
                      variant="body2"
                    >
                      GESTISCI DISPONIBILITÀ
                    </Typography>
                  </label>
                </Box>
                <Box display={"flex"} alignItems="center">
                  <input
                    type="radio"
                    id="option_prezzo"
                    name="options"
                    value="prezzo"
                    checked={value === "prezzo"}
                    onChange={handleChange}
                    style={{ marginRight: "10px" }} // Optional for spacing
                  />
                  <label htmlFor="option_prezzo" style={{ cursor: "pointer" }}>
                    <Typography
                      sx={{
                        fontSize: "18px",
                      }}
                      variant="body2"
                    >
                      NUOVO PREZZO
                    </Typography>
                  </label>
                </Box>
                <Box display={"flex"} alignItems="center">
                  <input
                    type="radio"
                    id="option_min_nights"
                    name="options"
                    value="minNights"
                    checked={value === "minNights"}
                    onChange={handleChange}
                    style={{ marginRight: "10px" }} // Optional for spacing
                  />
                  <label
                    htmlFor="option_min_nights"
                    style={{ cursor: "pointer" }}
                  >
                    <Typography
                      sx={{
                        fontSize: "18px",
                      }}
                      variant="body2"
                    >
                      IMPONI MINIMO NOTTI
                    </Typography>
                  </label>
                </Box>
              </Stack>
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "ivymode",
                  marginBottom: "10px",
                }}
              >
                2. Seleziona la stanza
              </Typography>
              {value === "minNights" ? (
                <RadioSelector
                  rooms={rooms}
                  selectedRooms={selectedRoomsMinNights}
                  onChange={(e) =>
                    handleMinNightsChange(
                      e,
                      selectedRoomsMinNights,
                      setSelectedRoomsMinNights
                    )
                  }
                />
              ) : (
                <RoomSelector
                  rooms={rooms}
                  selectedRoom={selectedRoom}
                  onChange={(e) => handleRadioChange(e, setSelectedRoom)}
                />
              )}

              <Divider
                sx={{
                  width: "100%",
                  height: "0.1px",
                  opacity: 0.2,
                  margin: "2vw 0",
                  backgroundColor: "#D9D9D9",
                }}
              />
              <Divider
                sx={{
                  width: "100%",
                  height: "0.1px",
                  opacity: 0.2,
                  margin: "2vw 0",
                  backgroundColor: "#D9D9D9",
                }}
              />
              <Stack
                style={{
                  display: value === "" ? "none" : "block",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "ivymode",
                    margintop: "10px",
                  }}
                >
                  3. Seleziona le date
                </Typography>

                <DateRangePicker
                  bookingDates={bookingDates}
                  popoverPlacement="top"
                  handleStartDateChange={(date) =>
                    handleDateChange(date, true, bookingDates, setBookingDates)
                  }
                  handleEndDateChange={(date) =>
                    handleDateChange(date, false, bookingDates, setBookingDates)
                  }
                />
                <Typography
                  variant="h6"
                  sx={{
                    margin: "30px 0",
                    fontFamily: "ivymode",
                  }}
                >
                  4. Inserisci i dettagli
                </Typography>
                <Box pb={2}>
                  {value === "minNights" && (
                    <Box mt={2}>
                      <Typography variant="subtitle1">Minimo Notti</Typography>
                      <TextField
                        type="number"
                        value={minNights}
                        onChange={(e) => setMinNights(Number(e.target.value))}
                        placeholder="Inserisci il minimo di notti"
                        fullWidth
                        inputProps={{ min: 1 }}
                      />
                    </Box>
                  )}
                  {value === "prezzo" && (
                    <Stack spacing={2}>
                      {" "}
                      <TextField
                        sx={{ width: "100%" }}
                        label="Inserisci il prezzo (lascia 0 se non vuoi impostarne uno nuovo)"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                      />{" "}
                    </Stack>
                  )}
                  {value === "disponibilità" && (
                    <Stack spacing={2}>
                      <NumberInput
                        label="Numero di adulti"
                        value={adultsCount}
                        onChange={setAdultsCount}
                      />
                      <NumberInput
                        label="Numero di bambini"
                        value={childrenCount}
                        onChange={setChildrenCount}
                      />
                      <TextField
                        label="Nome del cliente"
                        value={customerName}
                        onChange={(e) => setCustomerName(e.target.value)}
                      />
                      <TextField
                        label="Numero di telefono"
                        value={customerPhone}
                        onChange={(e) => setCustomerPhone(e.target.value)}
                      />
                      <TextField
                        label="Numero di prenotazione"
                        value={prenotazione}
                        onChange={(e) => setPrenotazione(e.target.value)}
                      />
                      <TextField
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <TextField
                        label="Prezzo"
                        value={newPrice}
                        onChange={(e) => setNewPrice(e.target.value)}
                      />
                    </Stack>
                  )}
                </Box>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "black",
                    color: "white",
                    width: "100%",
                  }}
                  type="submit"
                >
                  Invia
                </Button>
              </Stack>
            </Stack>
          </Box>
        </form>
      </Box>

      {/* implementa tabs */}

      <Box display={tabValue === 3 ? "block" : "none"}>
        <Tabs value={subTabValue} onChange={handleChangeTab} centered>
          <Tab label="Prezzi Mensili" />
          <Tab label="Minimo Notti" />
        </Tabs>
        <Box sx={{ display: "flex", justifyContent: "center" }} width={"100%"}>
          <Box display={subTabValue === 0 ? "block" : "none"} width={"100%"}>
            <Box width={"100%"} p={"20px 10px"}>
              <Stack spacing={2} alignContent={"center"} sx={{ width: "100%" }}>
                {Object.keys(groupedPrices).map((month) => (
                  <Box key={month} sx={{ marginBottom: 3 }}>
                    <Typography
                      variant="h6"
                      sx={{ fontFamily: "ivymode", marginBottom: 1 }}
                    >
                      Prezzi per {month}
                    </Typography>
                    {Object.keys(groupedPrices[month]).map((roomTitle) => (
                      <Box
                        key={roomTitle}
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          padding: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <Typography variant="h6">{roomTitle}</Typography>
                        {groupedPrices[month][roomTitle].map((price) => (
                          <Box
                            key={price.id}
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box p={"10px 0"} gap={"10px"}>
                              <Typography
                                sx={{ fontFamily: "degular", fontSize: "18px" }}
                              >
                                {getRoomTitle(price.roomId)}
                              </Typography>
                              <Typography
                                sx={{
                                  fontFamily: "degular",
                                  letterSpacing: "1px",
                                  fontWeight: "500",
                                  fontSize: "18px",
                                }}
                              >
                                PREZZO GIORNALIERO: €
                                {editingPriceId === price.id ? (
                                  <TextField
                                    type="number"
                                    value={newPrice}
                                    onChange={(e) =>
                                      setNewPrice(e.target.value)
                                    }
                                    size="small"
                                    inputProps={{ min: 0 }}
                                  />
                                ) : (
                                  price.price
                                )}
                              </Typography>
                              Dal{" "}
                              {price.startDate.toDate().toLocaleDateString()} al{" "}
                              {price.endDate.toDate().toLocaleDateString()}
                            </Box>
                            <Box display="flex" alignItems="center">
                              {editingPriceId === price.id ? (
                                <Button
                                  variant="contained"
                                  size="small"
                                  onClick={() => handleSavePrice(price.id)}
                                  sx={{ marginLeft: 1 }}
                                >
                                  Salva
                                </Button>
                              ) : (
                                <IconButton
                                  aria-label="edit"
                                  size="small"
                                  onClick={() =>
                                    handleEditPrice(price.id, price.price)
                                  }
                                >
                                  <EditIcon fontSize="small" />
                                </IconButton>
                              )}
                              <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={() => handleDeletePrice(price.id)}
                                disabled={loading}
                              >
                                {loading ? (
                                  <CircularProgress size={20} />
                                ) : (
                                  <DeleteIcon fontSize="small" />
                                )}
                              </IconButton>
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    ))}
                  </Box>
                ))}
              </Stack>
            </Box>
          </Box>

          <Box display={subTabValue === 1 ? "block" : "none"} width={"100%"}>
            <Box width={"100%"} p={"20px 10px"}>
              <Stack spacing={2} alignContent={"center"} sx={{ width: "100%" }}>
                {minNightsData && minNightsData.length > 0 ? (
                  minNightsData.map((minNight) => {
                    const month = minNight.startDate
                      .toDate()
                      .toLocaleString("default", {
                        month: "long",
                        year: "numeric",
                      });

                    const roomTitle = getRoomTitle(minNight.roomId);

                    return (
                      <Box key={minNight.id} sx={{ marginBottom: 3 }}>
                        {/* Heading per Minimo notti */}
                        <Typography
                          variant="h6"
                          sx={{ fontFamily: "ivymode", marginBottom: 1 }}
                        >
                          Minimo notti per {month}
                        </Typography>
                        <Box
                          sx={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "10px",
                            marginBottom: "10px",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            {" "}
                            <Typography variant="h6">{roomTitle}</Typography>
                            <Typography
                              sx={{
                                fontFamily: "degular",
                                letterSpacing: "1px",
                                fontWeight: "500",
                                fontSize: "18px",
                              }}
                            >
                              Minimo di notti:
                              {editingMinNightsId === minNight.id ? (
                                <TextField
                                  type="number"
                                  value={newPrice}
                                  onChange={(e) =>
                                    setNewMinNights(e.target.value)
                                  }
                                  size="small"
                                  inputProps={{ min: 0 }}
                                />
                              ) : (
                                minNight.minNights
                              )}
                            </Typography>
                            <Typography variant="body2">
                              Dal{" "}
                              {minNight.startDate.toDate().toLocaleDateString()}{" "}
                              al{" "}
                              {minNight.endDate.toDate().toLocaleDateString()}
                            </Typography>
                          </Box>

                          <Box display="flex" alignItems="center">
                            <IconButton
                              aria-label="delete"
                              size="small"
                              onClick={() => handleDeleteMinNights(minNight.id)}
                              disabled={loading}
                            >
                              {loading ? (
                                <CircularProgress size={20} />
                              ) : (
                                <DeleteIcon fontSize="small" />
                              )}
                            </IconButton>
                          </Box>
                        </Box>
                      </Box>
                    );
                  })
                ) : (
                  <Typography variant="body1">
                    Nessun dato disponibile per il minimo delle notti.
                  </Typography>
                )}
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TabManageBookings;
